import { render, staticRenderFns } from "./Businessunit.vue?vue&type=template&id=f28dbbf8"
import script from "./Businessunit.vue?vue&type=script&lang=js"
export * from "./Businessunit.vue?vue&type=script&lang=js"
import style0 from "./Businessunit.vue?vue&type=style&index=0&id=f28dbbf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports